var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{staticClass:"create-order-flat-rate",attrs:{"paddingMainContents":false}},[_c('Panel',{staticClass:"text-blue-800",attrs:{"title":"แก้ไขใบส่งสินค้า"}},[_c('CommonFormWithDeliveryFlatRate',{attrs:{"edit":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }